import request from '@/axios'

// 设备列表
export function getDevice(data={}) {
    return request({
        url: '/device/listByPage',
        method: 'get',
        params: data
    })
}
// 设备列表--小云菇
export function getDevices(data={}) {
    return request({
        url: '/device/listByPages',
        method: 'post',
        data
    })
}
// 设备的订单列表
export function getRecordes(data={}) {
    return request({
        url: '/payment/getRecordes',
        method: 'post',
        params: data
    })
}

// 获取端口状态
export function getPortStatus(data={}) {
    return request({
        url: '/charging/startinfo',
        method: 'post',
        params: data
    })
}
// 远开（远程开启）
export function remoteOpen(data={}) {
    return request({
        url: '/charging/start',
        method: 'post',
        params: data
    })
}
// 远关（远程关闭）
export function remoteClose(data={}) {
    return request({
        url: '/charging/stop',
        method: 'post',
        params: data
    })
}
// 获取订单详情
export function getOrderInfo(data={}) {
    return request({
        url: '/charging/orderInfo',
        method: 'post',
        params: data
    })
}
